// package.json
var version = "0.45.1";

// src/version.ts
var compatibilityVersion = 10;
export {
  compatibilityVersion,
  version as npmVersion
};
